import styled from "styled-components";
import { BaseButton } from "@shared/styles/common.styled";

export const HeaderWrapper = styled.div`
  background-color: ${(props) =>
    props?.backgroundColor ? props.backgroundColor : "#004c83"};
  display: flex;
  justify-content: space-between;
  padding: 5px 30px;
  border-radius: 5px 5px 0px 0px;
`;

export const Title = styled.h3`
  color: white !important;
  text-align: left;
  width: 100%;
  font-family: "Lato";
  font-size: 20px;
  line-height: 20px;
  margin: 0;
  font-weight: normal;
`;

export const SolutionContainer = styled.div`
  margin-left: 10px;
  display: ${(props) => (props?.display ? props.display : "none")};
`;

export const GrayDarkerSpan = styled.span`
  color: #474747;
`;

export const GraySpan = styled.span`
  color: #767676;
`;

export const PriceContainer = styled.span`
  margin-right: 10px;
`;

export const SolutionAllocation = styled.span`
  font-family: Lato;
  font-size: 22px;
  font-weight: 700;
  line-height: 49px;
  letter-spacing: 0px;
  text-align: center;
  color: #0a4986;
  background: #ffffff;
`;

export const Separator = styled.hr`
  background: #ededed;
  border: 1px solid #ededed;
  width: 100%;
  margin-top: 0px !important;
  margin-bottom: 5px !important;
`;

export const SolutionName = styled.span`
  position: relative;
  font-size: 16px;
  line-height: 24px;
  font-weight: 700;
  color: #084987 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: underline !important;
  cursor: pointer;
  text-transform: initial;
  margin: 0;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center};
  > div {
    margin-right: 1rem;
  }
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  opacity: ${(props) => (props?.opacity ? props.opacity : 1)};
  margin-right: ${(props) => (props?.marginRight ? props.marginRight : "0px")};
  margin-top: ${(props) => (props?.marginTop ? props.marginTop : "0px")};
  background-color: ${(props) =>
    props?.backgroundColor ? props.backgroundColor : "#fff"};
`;

export const OuterDiv = styled.div`
  padding: 10px;
  // background: linear-gradient(
  //   180deg,
  //   rgba(255, 255, 255, 0) 0%,
  //   rgba(255, 255, 255, 0.5) 14.95%,
  //   rgba(0, 76, 127, 0.1) 100%
  // );
`;

export const GridLabel = styled.span`
  text-align: ${(props) => props.textAlign ?? "center"};
  color: ${(props) => props.color ?? "#fff"};
  font-weight: 700;
  background-color: #00aeea;
  padding: 5px;
  font-size: 12px;
  border-radius: ${(props) => props.borderRadius ?? " 0px 0px 0px 0px"};
`;

export const GridSubLabel = styled.span`
  text-align: ${(props) => props.textAlign ?? "center"};
  color: ${(props) => props.color ?? "#474747"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: #fff;
  padding: 10px 5px;
  font-size: 12px;
  align-self: ${(props) => props.alignSelf ?? "center"};
`;

export const CommentButton = styled.button`
  min-width: unset;
  background-color: transparent;
  border: none;
  padding: 0px;
  height: auto;
`;

export const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  padding: 10px;
  height: auto;
  position: absolute;
  right: 0;
  top: 0;
`;

export const CommentsTitle = styled.h2`
  font-size: 16px;
  font-family: Lato;
  line-height: 22px;
  margin: 0;
  color: #474747;
  border-bottom: 1px solid #767676;
  padding-bottom: 10px;
`;

export const GroupComments = styled.div`
  padding-top: 10px;
`;

export const CommentsTextTitle = styled.h2`
  font-size: 16px;
  line-height: 22px;
  font-family: Lato;
  font-weight: bold;
  margin: 10px 0 0 0;
  text-align: left;
  color: #474747;
  text-transform: initial;
`;

export const CommentText = styled.p`
  font-size: 16px;
  line-height: 22px;
  font-family: Lato;
  margin: 0 0 10px 0;
  text-align: left;
`;

export const IDButton = styled(BaseButton)`
  color: #0a4986;
  text-decoration: none;
  background-color: transparent;
  border: unset;
  margin: 0;
  padding: 0;
  font-size: 10x;
  color: #0a4986;
  font-weight: 700;
  text-decoration: underline;
`;

export const HorizontalRow = styled.div`
  border: 1px solid #cccccc;
  width: 100%;
`;
